import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OntoManagesChildrenRequestActionTypes, OntologyLevels } from '../models/ontoloy-master';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import get from 'lodash/get';

const page_name = 'ontologyMaster';

export interface useCaseStates {
  ontologyData: Array<OntologyLevels>;
  isOntologyDataLoading: Boolean;
  ontologyDataHasError: Boolean;
  ontologyMgmntDataHasError: Boolean;
  isAddOntologyMasterLoading: Boolean;
  isAddOntologyMasterFailed: Boolean;
  isAddOntologyMasterSuccess: Boolean;
  isSaveOntologyLoading: Boolean;
  isSaveOntologySuccess: Boolean;
  isSaveOntologyFailed: Boolean;
  selectedMaster: any;
  addedItems: any;
  ontologyMgmntData: Array<any>;
  levelMaster: Array<any>;
  ontologyMessage: String;
  isUpdateOntologyMasterSuccess: Boolean;
  isUpdateOntologyMasterFailed: Boolean;
  isOntoManagesLoading: Boolean;
  OntoManages: Array<any>;
  isOntoManagesReqFailed: Boolean;
}

const initialState: useCaseStates = {
  ontologyData: [],
  isOntologyDataLoading: false,
  ontologyDataHasError: false,
  ontologyMgmntDataHasError: false,
  isAddOntologyMasterLoading: false,
  isAddOntologyMasterFailed: false,
  isAddOntologyMasterSuccess: false,
  isSaveOntologyLoading: false,
  isSaveOntologySuccess: false,
  isSaveOntologyFailed: false,
  selectedMaster: {},
  addedItems: [],
  ontologyMgmntData: [],
  levelMaster: [],
  ontologyMessage: '',
  isUpdateOntologyMasterSuccess: false,
  isUpdateOntologyMasterFailed: false,
  isOntoManagesLoading: false,
  OntoManages: [],
  isOntoManagesReqFailed: false,
};

const OntgologyMasterReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getOntologyList: (state, action: { payload: string }) => {
      state.isOntologyDataLoading = true;
      state.isAddOntologyMasterSuccess = false;
    },
    getOntologyResponse: (state, action) => {
      state.isOntologyDataLoading = false;
      state.ontologyData = get(action, 'payload.res', []);
    },
    ontologyResponseFailed: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.ontologyDataHasError = true;
      state.ontologyData = [];
      const message = getStatusMessage(page_name, action.payload);
      state.ontologyMessage = message;
      Snackbar.error(message);
    },
    saveOntologyData: (state, action: PayloadAction<Array<OntologyLevels>>) => {
      state.isOntologyDataLoading = true;
      state.isSaveOntologyLoading = true;
      state.isSaveOntologySuccess = false;
      state.isSaveOntologyFailed = false;
      state.isAddOntologyMasterSuccess = false;
    },
    saveOntologyResponse: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isSaveOntologyLoading = false;
      state.isSaveOntologySuccess = true;
      state.isSaveOntologyFailed = false;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    saveOntologyFailed: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isSaveOntologyLoading = false;
      state.isSaveOntologySuccess = false;
      state.isSaveOntologyFailed = true;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    updateLevelmasterBulk: (state, action: PayloadAction<Array<OntologyLevels>>) => {
      state.isOntologyDataLoading = true;
      state.isSaveOntologyLoading = true;
      state.isSaveOntologySuccess = false;
      state.isSaveOntologyFailed = false;
      state.isAddOntologyMasterSuccess = false;
    },
    updateLevelmasterBulkResponse: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isSaveOntologyLoading = false;
      state.isSaveOntologySuccess = true;
      state.isSaveOntologyFailed = false;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    updateLevelmasterBulkFailed: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isSaveOntologyLoading = false;
      state.isSaveOntologySuccess = false;
      state.isSaveOntologyFailed = true;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    getOntologyMgmntList: (state, action: { payload: string }) => {
      state.isOntologyDataLoading = true;
      state.isAddOntologyMasterSuccess = false;
    },
    getOntologyMgmntResponse: (state, action) => {
      state.isOntologyDataLoading = false;
      state.ontologyMgmntData = action.payload.res;
      state.isAddOntologyMasterSuccess = true;
    },
    ontologyMgmntResponseFailed: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.ontologyMgmntDataHasError = true;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    addOntologyMasterReq: (state, action: any) => {
      state.isAddOntologyMasterLoading = true;
      state.isAddOntologyMasterSuccess = false;
      state.isAddOntologyMasterFailed = false;
    },
    addOntologyMasterResponse: (state, action: any) => {
      state.isAddOntologyMasterLoading = false;
      state.isAddOntologyMasterSuccess = true;
      state.isAddOntologyMasterFailed = false;
      state.addedItems = action.payload.data.data;
      state.levelMaster = state.levelMaster.map((items: any) => {
        if (items.level_number === action.payload.data.data.onto_level_number) {
          items.onto_manages.push(action.payload.data.data);
        }
        return { ...items };
      });
      state.ontologyMessage = getStatusMessage(page_name, action.payload.code);
    },
    addOntologyMasterFailed: (state, action: any) => {
      state.isAddOntologyMasterLoading = false;
      state.isAddOntologyMasterSuccess = false;
      state.isAddOntologyMasterFailed = true;
      state.ontologyMessage = getStatusMessage(page_name, action.payload);
    },
    updateOntologyMasterReq: (state, action: any) => {
      state.isOntologyDataLoading = true;
      state.isUpdateOntologyMasterSuccess = false;
      state.isUpdateOntologyMasterFailed = false;
    },
    updateOntologyMasterResponse: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isUpdateOntologyMasterSuccess = true;
      state.isUpdateOntologyMasterFailed = false;
      state.addedItems = action.payload.data.data;
      const message = getStatusMessage(page_name, action.payload?.code);
      state.ontologyMessage = message;
      // Snackbar.success(message);
    },
    updateOntologyMasterFailed: (state, action: any) => {
      state.isOntologyDataLoading = false;
      state.isUpdateOntologyMasterSuccess = false;
      state.isUpdateOntologyMasterFailed = true;

      const message = getStatusMessage(page_name, action.payload);
      state.ontologyMessage = message;
      // Snackbar.error(message);
    },
    setCurrentLevelMaster: (state, action) => {
      state.levelMaster = action.payload;
    },
    getFactoriesOntologiesRequest: (state, action: OntoManagesChildrenRequestActionTypes) => {
      state.isOntoManagesLoading = true;
      state.isOntoManagesReqFailed = false;
    },
    getFactoriesOntologiesResponse: (state, action: any) => {
      state.isOntoManagesLoading = false;
      state.OntoManages = get(action, 'payload.res', []);
    },
    getFactoriesOntologiesFailed: (state) => {
      state.isOntoManagesLoading = false;
      state.isOntoManagesReqFailed = true;
    },
    resetLoadingState: (state) => {
      state.isOntologyDataLoading = false;
      state.isSaveOntologyLoading = false;
      state.isSaveOntologySuccess = false;
      state.isSaveOntologyFailed = false;
      state.isAddOntologyMasterSuccess = false;
      state.isAddOntologyMasterFailed = false;
      state.ontologyMessage = '';
      state.ontologyDataHasError = false;
      state.ontologyMgmntDataHasError = false;
      state.isUpdateOntologyMasterSuccess = false;
      state.isUpdateOntologyMasterFailed = false;
    },
  },
});

export const ontologyMasterActions = OntgologyMasterReducer.actions;
export default OntgologyMasterReducer;
